<template>
  <button
    :type="type"
    :disabled="disabled"
    :style="style"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
  import { type PropType } from 'vue';

  type ButtonType = 'button' | 'submit' | 'reset';

  defineProps({
    type: {
      type: String as PropType<ButtonType>,
      default: 'button',
      validator: (value: string): boolean =>
        ['button', 'submit', 'reset'].includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    style: {
      type: Object as PropType<Record<string, string>>,
      default: () => ({})
    }
  });

  defineEmits<{
    (e: 'click', event: MouseEvent): void;
  }>();
</script>
